// src/main.js

// --- Основни увози ---
import Vue from "vue";
import App from "./App.vue";
import router from "./router";

// --- Quasar Framework (компоненти, стилови и икони) ---
import Quasar from "quasar";
import "quasar/dist/quasar.min.css";
import "@quasar/extras/material-icons/material-icons.css";

// --- Глобални стилови (твој фајл за прилагодување) ---
import "./assets/styles/main.css";

// --- Конфигурација на Vue ---
Vue.config.productionTip = false;

// --- Иницијализација на Quasar ---
Vue.use(Quasar, {
  config: {
    brand: {
      primary: "#00bfa5", // Mint плава боја за копчиња и полиња
      secondary: "#ffffff", // Бела позадина
      accent: "#00796b", // Потемен нијанс за hover ефекти
      dark: "#263238", // Темно сива за текст или темна тема
    },
  },
});

// --- Иницијализација на главната Vue апликација ---
new Vue({
  router, // Рутер за навигација
  render: (h) => h(App), // Главна компонента App.vue
}).$mount("#app");
